<template lang="html">
  <div class="content">
    <div class="ai-tabs tabs">
      <div class="actions" />
      <div>
        <div v-for="(tab, i) in tabs"
             :key="i"
             class="ai-tabs__tab"
             :class="{'ai-tabs__tab--active': tab.value === activeTab}"
             @click="switchTo(tab.value)">
          {{ tab.name }}
        </div>
      </div>
      <div class="ai-input-group actions">
        <div class="ai-button ai-button--primary new-sub-account actions__add-btn"
             @click="createSubDialogVisible = true">
          <i class="material-icons">add</i>
          添加子账户
        </div>
        <input type="text"
               class="ai-input ai-input-group__input actions__search-input"
               placeholder="请输入搜索内容">
        <div class="ai-button ai-input-group__button actions__search-btn">
          <i class="material-icons">search</i>
        </div>
      </div>
    </div>
    <div class="table-wrapper">
      <table class="table">
        <thead>
          <tr>
            <th>子账户名</th>
            <th>创建时间</th>
            <th>联系人</th>
            <th>联系电话</th>
            <th>店铺品牌</th>
            <th>所属商场</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in subaccounts" :key="index">
            <td>{{ item.username }}</td>
            <td>{{ item.created_at | timeFormatter }}</td>
            <td>{{ item.contact_name }}</td>
            <td>{{ item.contact_phone }}</td>
            <td>{{ item.store_name }}</td>
            <td>上海红星金桥店</td>
            <td>
              <div class="ai-button ai-button--text ai-button--text--primary"
                   @click="$message.basic('功能开发中')">
                编辑权限
              </div>
              <div class="ai-button ai-button--text ai-button--text--primary"
                   @click="$message.basic('功能开发中')">
                密码
              </div>
              <div class="ai-button ai-button--text ai-button--text--danger"
                   @click="showConfirm(item.id)">
                删除
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <AiPagination v-model="currentPage"
                  class="pagination"
                  :total-page-count="totalPageCount"
                  @change="getData" />
    <AiDialog class="create-sub-dialog"
              width="435"
              :visible.sync="createSubDialogVisible"
              @close="clearDialogInputs">
      <div slot="header" class="create-sub-dialog__header">
        添加子账户
      </div>
      <div class="create-sub-dialog__content">
        <form class="form">
          <div class="form-item">
            <label class="form-item__label">
              子账户名:
            </label>
            <div class="form-item__content">
              <AiInput v-model="newAccount.userName" type="text" placeholder="请输入" />
            </div>
          </div>
          <div class="form-item">
            <label class="form-item__label">
              品牌名称:
            </label>
            <div class="form-item__content">
              <AiInput v-model="newAccount.storeName" type="text" placeholder="请输入" />
            </div>
          </div>
        </form>
      </div>
      <div slot="footer" class="create-sub-dialog__footer">
        <div class="ai-button ai-button--primary"
             :class="{'ai-button--disabled': loading, 'ai-button--disabled--primary': loading}"
             @click="createNewSubAccount">
          确 定
        </div>
        <div class="ai-button" @click="closeDialog">
          取 消
        </div>
      </div>
    </AiDialog>
  </div>
</template>

<script>
import moment from 'moment';

const createSuccess = require('@/assets/views/users/create_success.svg');
const deleteSuccess = require('@/assets/views/users/delete_success.svg');

export default {
  filters: {
    timeFormatter(val) {
      return moment(val).format('YYYY-MM-DD HH:mm:ss');
    }
  },
  data() {
    return {
      vrScene: {
        type: Object,
        default: null
      },
      activeTab: 'sub-accounts',
      tabs: [{
        name: '我的账户',
        value: 'my-account'
      }, {
        name: '子账户管理',
        value: 'sub-accounts'
      }],
      createSubDialogVisible: false,
      loading: false,
      totalPageCount: 20,
      currentPage: 1,
      subaccounts: [],
      newAccount: {
        userName: '',
        storeName: ''
      }
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    switchTo(tabValue) {
      this.activeTab = tabValue;
    },
    showConfirm(id) {
      this.$confirm({
        title: '确认要删除该子账户吗?',
        message: '删除后, 该子账户将失去所有编辑权限, 并无法登录本管理系统!'
      }).then(() => {
        this.deleteSubAccount(id);
      }).catch(() => {});
    },
    async getData() {
      const params = { page_num: this.currentPage };

      try {
        const { data: { data } } = await this.$http.post('/admin/list-subaccounts', params);
        if (data) {
          this.subaccounts = data.subaccounts;
          this.currentPage = data.pageNum;
          this.totalPageCount = data.pageCount;
        }
      } catch (error) {
        this.$message.basic(error.error_msg);
      }
    },
    closeDialog() {
      this.clearDialogInputs();
      this.createSubDialogVisible = false;
    },
    clearDialogInputs() {
      this.newAccount.userName = '';
      this.newAccount.storeName = '';
    },
    async createNewSubAccount() {
      this.loading = true;
      const params = {
        username: this.newAccount.userName,
        store_name: this.newAccount.storeName
      };

      try {
        const { data } = await this.$http.post('/admin/add-subaccount', params);
        if (data && data.error_no === 200) {
          this.$message.basic({
            message: '添加成功!',
            icon: createSuccess
          });
          this.loading = false;
          this.closeDialog();
          this.getData();
        }
      } catch (error) {
        // error
      }
    },
    async deleteSubAccount(id) {
      const params = { subaccount_id: id };

      try {
        const { data } = await this.$http.post('/admin/delete-subaccount', params);
        if (data && data.error_no === 200) {
          this.$message.basic({
            message: '删除成功!',
            icon: deleteSuccess
          });
          this.getData();
        }
      } catch (error) {
        // error
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.tabs {
  width: 100%;
  margin: 10px 0;
  justify-content: space-between;
}

.actions {
  margin: 0 40px;
  width: 347px;

  &__add-btn {
    width: 89px;
    height: 22px;
    font-size: 11px;
    margin-right: 24px;

    .material-icons {
      margin-right: 0;
      font-size: 14px;
    }
  }

  &__search-input {
    width: 183px;
    height: 22px;
  }

  &__search-btn {
    width: 22px;
    height: 22px;

    .material-icons {
      margin: 0;
      font-size: 14px;
      color: #9e9e9e;
    }
  }
}

.table-wrapper {
  margin: 0 40px;
}

.table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 8px;

  tr {
    height: 50px;
  }

  th {
    border: 0;
    font-size: 12px;
    color: #888;
  }

  thead {
    th {
      background-color: #ddeffb;

      &:first-child {
        border-top-left-radius: 4px;
      }

      &:last-child {
        border-top-right-radius: 4px;
      }
    }
  }

  tbody {
    td {
      background-color: white;
      border-bottom: 1px solid #eee;
    }

    tr:last-child td {
      border-bottom: 0;
    }

    tr:last-child td:first-child {
      border-bottom-left-radius: 4px;
    }

    tr:last-child td:last-child {
      border-bottom-right-radius: 4px;
    }
  }

  td {
    text-align: center;
    color: #888;
    font-size: 12px;
  }
}

.pagination {
  width: 100%;
  margin: 38px 0;
}

.create-sub-dialog {
  &__header {
    height: 50px;
    display: flex;
    align-items: center;
    margin-left: 20px;
    font-weight: 500;
    color: #6c6c6c;
  }

  &__content {
    width: 435px;
    height: 76px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;
  }

  &__footer {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    flex-direction: row-reverse;

    .ai-button {
      width: 59px;
      height: 26px;
      margin: 0 10px;
      font-size: 14px;
    }
  }
}

.form-item {
  margin-bottom: 20px;
  width: 100%;

  &:last-child {
    margin-bottom: 0;
  }

  &__label {
    display: inline-block;
    width: 80px;
    text-align: right;
    color: #6c6c6c;
    font-size: 14px;
  }

  &__content {
    display: inline-block;
    margin-left: 12px;

    .ai-input-wrapper {
      width: 240px;
      height: 28px;
    }
  }
}
</style>
